import React from 'react';
import { useForm, ValidationError } from '@formspree/react';

const Contact = () => {
  const [state, handleSubmit] = useForm('mwlkkwga');

  if (state.succeeded) {
    return (
      <section id="contact" className="section contact" aria-labelledby="contact-title">
        <div className="container">
          <div className="contact__success">
            <span className="contact__success-icon" aria-hidden="true">✓</span>
            <p className="section__tagline">Message Received</p>
            <h2 id="contact-title" className="section__title">
              Thank you for reaching out.
            </h2>
            <p className="section__description">
              Your inquiry is on its way. I’ll get back to you soon to discuss your session.
            </p>
            <a href="#portfolio" className="btn btn--secondary">
              View the Portfolio
            </a>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="contact" className="section contact" aria-labelledby="contact-title">
      <div className="container">
        <header className="section__header">
          <span className="section__tagline">Let’s Create Something Meaningful</span>
          <h2 id="contact-title" className="section__title">
            Start Your Story
          </h2>
          <p className="section__description">
            Tell me a little about your vision, date, and photography needs. I’ll be in touch
            to plan an experience that feels uniquely yours.
          </p>
        </header>

        <div className="contact__layout">
          <aside className="contact__details" aria-label="Contact details">
            <p className="contact__details-title">Ready when you are.</p>
            <p className="contact__details-text">
              For real estate, portrait, commercial, and branding shoots, use the form or email
              me directly. You'll hear back from me personally — not an assistant.
            </p>

            <a
              className="contact__email"
              href="mailto:info@justinshamoka.photos"
            >
              info@justinshamoka.photos
            </a>

            <p className="contact__response-note">
              I typically respond within 1–2 hours.
            </p>
          </aside>

          <form className="contact__form" onSubmit={handleSubmit}>
            <input
              type="hidden"
              name="_subject"
              value="New photography inquiry — Justin Shamoka Photography"
            />

            <div className="contact__field-row">
              <div className="contact__field">
                <label htmlFor="name">Your name</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  autoComplete="name"
                  required
                  placeholder="Your name"
                />
                <ValidationError prefix="Name" field="name" errors={state.errors} />
              </div>

              <div className="contact__field">
                <label htmlFor="email">Email address</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  placeholder="you@example.com"
                />
                <ValidationError prefix="Email" field="email" errors={state.errors} />
              </div>
            </div>

            <div className="contact__field-row">
              <div className="contact__field">
                <label htmlFor="service">What are you looking for?</label>
                <select id="service" name="service" defaultValue="" required>
                  <option value="" disabled>
                    Select a service
                  </option>
                  <option value="Real estate photography">Real estate photography</option>
                  <option value="Portrait photography">Portrait photography</option>
                  <option value="Commercial photography">Commercial photography</option>
                  <option value="Branding photography">Branding photography</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div className="contact__field">
                <label htmlFor="eventDate">Preferred date</label>
                <input id="eventDate" name="eventDate" type="date" />
              </div>
            </div>

            <div className="contact__field">
              <label htmlFor="message">Tell me about your vision</label>
              <textarea
                id="message"
                name="message"
                rows="6"
                required
                placeholder="Include the location, what you'd like photographed, your timeline, and anything else I should know."
              />
              <ValidationError prefix="Message" field="message" errors={state.errors} />
            </div>

            {state.errors && (
              <p className="contact__form-error" role="alert">
                Something went wrong while sending your message. Please try again or email me
                directly at info@justinshamoka.photos.
              </p>
            )}

            <button
              type="submit"
              className="btn btn--primary"
              disabled={state.submitting}
            >
              {state.submitting ? 'Sending Inquiry…' : 'Send Inquiry'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;